<div
    [class.border-r]="index() !== 6"
    [style.min-height]="height()"
    class="border-t group item theme-border h-full"
>
    @if (selected() && options()?.day?.selected) {
        <div
            class="absolute inset-0 z-10 w-full h-full border-2 pointer-events-none border-primary"
        ></div>
    }
    <div class="flex justify-center items-center w-full md:justify-between">
        <p
            class="rounded-full text theme-text"
            [attr.data-text]="type()"
            [attr.data-background]="type()"
        >
            {{ day().format("DD") }}
        </p>

        <!-- 등록 버튼  -->
        @if (options()?.event?.create) {
            <button
                (click)="handleCreate($event)"
                class="group-hover:md:flex create-button hidden rounded-full bg-primary size-8 justify-center items-center z-[999]"
            >
                <app-icon name="mdi:plus" class="text-white" />
            </button>
        }

        <!-- 이벤트가 많아지면 overflow 처리 후 카운트 렌더링 -->
        @if (overflowCountForDay(); as count) {
            <div
                (click)="more.emit()"
                class="cursor-pointer absolute right-2 bottom-3 text-sm text-gray-500 bg-white/70 rounded px-1 py-[2px]"
            >
                +{{ count }} more
            </div>
        }
    </div>
    <app-block-calendar-mobile-event [day]="day()" />
</div>
